import { shapesDeepLevels } from '../../../mapConfig';

const getGeometryDeepLevel = geometryType =>
  shapesDeepLevels.findIndex(shapes => shapes.includes(geometryType));

export default getGeometryDeepLevel;
